import React from 'react'
import { OrderUtils } from '@front/volcanion/utils/'

import { TableCell, Icon } from '@mui/material'

const Priority = ({ row }) => {
  const priority = OrderUtils.getIsPriority(row)
  return (
    <TableCell padding='none'>
      {!!priority &&
        <Icon color='secondary'>{'star'}</Icon>
      }
    </TableCell>
  )
}

export default React.memo(Priority)
